// src/slices/customsrelease/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getCustomsRelease } from "./thunk";

const initialState = { customsRelease: [], pagination: {}, loading: false, error: null };

const customsReleaseSlice = createSlice({
  name: "customsRelease",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getCustomsRelease.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getCustomsRelease.fulfilled, (state, action) => {
        state.loading = false;
        state.customsRelease = action.payload.data || [];
        state.pagination = action.payload.pagination || {};
      })

      .addCase(getCustomsRelease.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  }
});

export default customsReleaseSlice.reducer;
